<div class="site-announcement" *ngIf="shouldDisplaySiteAnnouncement">
    <div class="message">
        <span class="head-message" [innerHtml]="getTruncatedHeadMessage()"></span>
        <span class="message-link" *ngIf="shouldDisplaySiteAnnouncementLink" (click)="showDetails()">
            {{ 'siteAnnouncement.linkText' | translate}}
        </span>
    </div>
    <mat-icon (click)="closeAnnouncement()">close</mat-icon>
</div>
